export function normalizeSearch(value: unknown) {
  return String(value ?? "").normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLocaleLowerCase("fr-FR");
}

export function matchesListSyntax(
  fields: Record<string, unknown>,
  expression: string
) {
  const normalizedFields = Object.fromEntries(
    Object.entries(fields).map(([key, value]) => [
      normalizeSearch(key), normalizeSearch(value)
    ])
  );
  const searchable = Object.values(normalizedFields).join(" ");
  const tokens = expression.match(
    /[\p{L}_]+:"[^"]*"|[\p{L}_]+:\S+|"[^"]*"|\S+/gu
  ) ?? [];
  return tokens.every((rawToken) => {
    const separator = rawToken.indexOf(":");
    if (separator > 0) {
      const key = normalizeSearch(rawToken.slice(0, separator));
      const value = normalizeSearch(
        rawToken.slice(separator + 1).replace(/^"|"$/g, "")
      );
      return normalizedFields[key] !== undefined
        && normalizedFields[key].includes(value);
    }
    return searchable.includes(
      normalizeSearch(rawToken.replace(/^"|"$/g, ""))
    );
  });
}

export function compareOptionalDates(
  left: string | null | undefined,
  right: string | null | undefined,
  direction: "asc" | "desc"
) {
  if (!left && !right) return 0;
  if (!left) return 1;
  if (!right) return -1;
  const comparison = new Date(left).getTime() - new Date(right).getTime();
  return direction === "asc" ? comparison : -comparison;
}
